import { RootState } from '@/models/root-state.model';
import { OpenedFrom } from '@/lib/gTagManager';
import { createSelector } from 'reselect';
import { isMobile } from 'react-device-detect';
import { selectUserDepositCount } from '@/store/wallet/selectors';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { envIsCanada, envIsMexico, envIsNormal, envIsSweden } from '@/constants/constants';
import { DrawerModel, DrawerName, GamesSearchModel } from '@/store/ui/reducers';

const selectUiState = (state: RootState) => state.ui;

export const selectUiIsSingleGame = (state: RootState): boolean => state.ui.isSingleGame;

export const selectRegistrationOpenedFrom = (state: RootState): OpenedFrom | null =>
  state.ui.registrationOpenedFrom;

export const selectLoginOpenedFrom = (state: RootState): OpenedFrom | null =>
  state.ui.loginOpenedFrom;

export const selectIsPhotoIdScanModalSeen = createSelector(
  selectUiState,
  uiState => uiState.photoIdScanModalSeen,
);

export const selectShowFluidQuickDeposit = createSelector(
  selectUiIsSingleGame,
  selectUserDepositCount,
  (isSingleGame, depositCount) =>
    Boolean(isSingleGame && depositCount && depositCount > 0 && !isMobile),
);

export const selectIsLobbyRoute = (pathname: string) =>
  createSelector(selectLocale, locale => {
    if (envIsCanada() || envIsMexico() || envIsSweden()) {
      return pathname === '/games';
    }
    return pathname === `/${locale}/games`;
  });

const selectDrawer = (state: RootState): DrawerModel => state.ui.drawer;
export const selectGamesSearch = (state: RootState): GamesSearchModel => state.ui.gamesSearch;

export const selectDrawerOptions = createSelector(
  selectDrawer,
  (drawer): { isOpen: boolean; drawerName: DrawerName | null } => {
    return { isOpen: drawer.isOpen, drawerName: drawer.drawerName };
  },
);

export const selectShouldDisplayOnHomepage = createSelector(selectLocale, locale => {
  if (envIsSweden()) return false;
  return !(envIsNormal() && ['fi', 'fi-en', 'th'].includes(locale));
});
